import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Operators extends CommonCRUD {}

export default Operators;
